import { createApi } from "@reduxjs/toolkit/query/react";
import { defaultBaseQuery } from "../../utils/API/fetchBaseQuery";
import { transformRequest } from "../../utils/API/requestMiddleware";
import { transformErrorResponse, transformSuccessResponse } from "../../utils/API/responseMiddleware";

const clientAPI = createApi({
    baseQuery: defaultBaseQuery,
    reducerPath: 'clientAPI',
    endpoints: (builder) => ({

        addClient: builder.mutation({
            query: (data) => ({
                url: `/Client/AddClient`,
                method: `POST`,
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),


        updateClient: builder.mutation({
            query: (data) => ({
                url: `/Client/UpdateClient`,
                method: `POST`,
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        updateClientToggle: builder.mutation({
            query: (data) => ({
                url: `/Client/UpdateClientToggle`,
                method: `POST`,
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getClientByClientId: builder.mutation({
            query: (data) => ({
                url: `/Client/GetClientByClientId?ClientID=${data}`,
                method: `GET`,
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getClientList: builder.mutation({
            query: (data) => ({
                url: `/Client/GetClients`,
                method: `POST`,
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        deleteClient: builder.mutation({
            query: (clientID) => ({
                url: `/Client/DeleteClient?ClientID=${clientID}`,
                method: `DELETE`,
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getAllMergeFieldsData: builder.mutation({
            query: (data) => ({
                url: `/Client/GetAllMergeFieldsData`,
                method: `POST`,
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        updateAllReportField: builder.mutation({
            query: (data) => ({
                url: `/Client/UpdateAllReportField`,
                method: `POST`,
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        updateCopyReportField: builder.mutation({
            query: (data) => ({
                url: `/Client/UpdateCopyReportField`,
                method: `POST`,
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        updateCalculationReportField: builder.mutation({
            query: (data) => ({
                url: `/Client/UpdateCalculationReportField`,
                method: `POST`,
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        updateImportReportField: builder.mutation({
            query: (data) => ({
                url: `/Client/UpdateImportReportField`,
                method: `POST`,
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        updateUserEntryReportField: builder.mutation({
            query: (data) => ({
                url: `/Client/UpdateUserEntryReportField`,
                method: `POST`,
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),


    }),
});

export const {
    useAddClientMutation,
    useUpdateClientMutation,
    useUpdateClientToggleMutation,
    useGetClientListMutation,
    useDeleteClientMutation,
    useGetClientByClientIdMutation,
    useGetAllMergeFieldsDataMutation,
    useUpdateAllReportFieldMutation,
    useUpdateCopyReportFieldMutation,
    useUpdateCalculationReportFieldMutation,
    useUpdateImportReportFieldMutation,
    useUpdateUserEntryReportFieldMutation
} = clientAPI;

export default clientAPI;